import { graphql } from '@graphql/__generated'

export const GET_PREMIUM_EVENTS_BY_ORGANISATION_URL = graphql(`
  query GetPremiumEventsByOrganisationUrlOverviews($url: String!) {
    getPremiumEventsByOrganisationUrl(url: $url) {
      ...EventOverview
    }
  }
`)

export const GET_PREMIUM_EVENTS_FOR_USER_ID = graphql(`
  query GetPremiumEventsForUserId {
    getPremiumEventsForUserId {
      ...EventOverview
    }
  }
`)
